import { useNavigate, useLocation } from "react-router-dom";
import { logout, useTypedDispatch } from "../../store";
import { 
  RiHome5Line, 
  RiHistoryLine, 
  RiFileListLine, 
  RiLogoutBoxRLine,
  RiCloseLine,
  RiRestaurantLine 
} from "react-icons/ri";
import classNames from "classnames";

interface MenuProps {
  setIsOpen: (value: boolean) => void;
  isOpen: boolean;
}

const Menu: React.FC<MenuProps> = ({ setIsOpen, isOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useTypedDispatch();

  const handleNavigation = (to: string) => {
    setIsOpen(false);
    navigate(to);
  };

  const handleLogout = () => {
    setIsOpen(false);
    dispatch(logout());
  };

  const menuItems = [
    { label: "Commandes", path: "/", icon: <RiHome5Line /> },
    { label: "Historique", path: "/order-history", icon: <RiHistoryLine /> },
    { label: "Mon Menu", path: "/my-menu", icon: <RiRestaurantLine /> },
    { label: "Conditions générales", path: "/conditions-generales", icon: <RiFileListLine /> },
  ];

  return (
    <>
      {/* Backdrop */}
      <div 
        className={classNames(
          "fixed inset-0 bg-black/50 z-40 transition-opacity duration-300",
          { "opacity-100": isOpen, "opacity-0 pointer-events-none": !isOpen }
        )}
        onClick={() => setIsOpen(false)}
      />

      {/* Sidebar */}
      <div 
        className={classNames(
          "fixed top-0 left-0 h-screen w-80 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out flex flex-col",
          { "translate-x-0": isOpen, "-translate-x-full": !isOpen }
        )}
      >
        <div className="p-6 flex justify-between items-center border-b border-gray-100">
          <h2 className="text-2xl font-bold text-primary">Menu</h2>
          <button 
            onClick={() => setIsOpen(false)}
            className="p-2 hover:bg-gray-100 rounded-full text-gray-500 transition-colors"
          >
            <RiCloseLine className="text-2xl" />
          </button>
        </div>

        <div className="flex-1 py-6 px-4 flex flex-col gap-2">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <div
                key={item.path}
                className={classNames(
                  "flex items-center gap-4 px-4 py-3 rounded-xl cursor-pointer transition-all font-medium text-lg",
                  {
                    "bg-primary text-white shadow-md shadow-red-200": isActive,
                    "text-gray-600 hover:bg-gray-50": !isActive,
                  }
                )}
                onClick={() => handleNavigation(item.path)}
              >
                <span className="text-2xl">{item.icon}</span>
                <span>{item.label}</span>
              </div>
            );
          })}
        </div>

        <div className="p-6 border-t border-gray-100">
          <button
            className="w-full flex items-center justify-center gap-3 bg-red-50 text-red-600 font-bold py-3 px-4 rounded-xl hover:bg-red-100 transition-colors"
            onClick={handleLogout}
          >
            <RiLogoutBoxRLine className="text-xl" />
            <span>Se déconnecter</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Menu;
